import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../util/util';

@Pipe({ name: 'docEvent' })
export class DocEventPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return Utils.docEvent(obj);
  }
}
